import { TGenericListReturn, TNumStr } from "@cakemail-org/ui-components-v2"
import { ChartData, ChartOptions, ChartType } from "chart.js"
//import { CampaignModel } from "../../models/campaign"

export type TCharts = {
    type?: ChartType,
    data: ChartData,
    options?: ChartOptions,
    height?: TNumStr,
    maxHeight?: TNumStr,
    //campaigns?: TGenericListReturn<CampaignModel>,
    showToolTip?: boolean,
    setShowToolTip?: (value: boolean) => void
}

export enum EChartExtraColor {
    "deepBlue" = "#0B7D83",
    "orange" = "#FA7D61",
    "lime" = "#B9F256",
    "blue" = "#57A1C9",
}